import t from '@jetshop/intl';
import Accordion from '../ui/Accordion';
import React from 'react';
import { styled } from 'linaria/react';
import DynamicCategoryContent from '../ui/DynamicCategoryContent';

const Wrapper = styled('div')`
  display: block;
  width: 100%;
  border-top: 1px solid #e8e8e8;
`;
const InnerWrapper = styled('div')`
  line-height: 1.5;
  font-size: 14px;
  padding-bottom: 20px;

  .videoWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
    margin: 10px 0;
  }
  .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .materials-ul {
    padding-left: 1rem;
    list-style: disc;
  }

  p {
    margin-bottom: 10px;
  }

  tr {
    vertical-align: top;
    background: #f7f7f7;
    &:nth-child(even) {
      background: white;
    }

    td,
    th {
      padding: 5px;
    }
  }
`;
const Description = styled('article')`
  line-height: 1.5;
  font-size: 14px;
  margin-bottom: 1rem;
`;

const AccordionItem = styled('div')`
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
`;
const AccordionTitle = styled('div')`
  display: flex;
  justify-items: space-between;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
  font-weight: bold;
  font-size: 14px;
  padding: 10px 0;
  + * > :first-child {
    margin-top: 1rem;
  }
`;

const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
`;
const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);

const ProductInfoAccordion = ({ product }) => {
  const materials = product?.customFields?.find(
    ({ key }) => key === 'materiale'
  );
  return (
    <Accordion single initialOpenIndexes={[0]}>
      {({ openIndexes, handleClick, AccordionContent }) => (
        <Wrapper>
          <AccordionItem>
            <AccordionTitle onClick={() => handleClick(0)}>
              <span>{t('Product description')}</span>
              <AccordionIndicator isOpen={openIndexes.includes(0)} />
            </AccordionTitle>
            <AccordionContent isOpen={openIndexes.includes(0)}>
              <InnerWrapper>
                <Description
                  dangerouslySetInnerHTML={{
                    __html: product.description
                  }}
                />
                {materials?.listValues ? (
                  <>
                    <strong>{t('Materials')}</strong>
                    <ul className="materials-list">
                      {materials.listValues.map((material, index) => (
                        <li key={index}>{material}</li>
                      ))}
                    </ul>
                  </>
                ) : null}
              </InnerWrapper>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem>
            <AccordionTitle onClick={() => handleClick(2)}>
              <span>{t('Payment & delivery')}</span>
              <AccordionIndicator isOpen={openIndexes.includes(2)} />
            </AccordionTitle>
            <AccordionContent isOpen={openIndexes.includes(2)}>
              <InnerWrapper>
                <DynamicCategoryContent id={176} />
              </InnerWrapper>
            </AccordionContent>
          </AccordionItem>
        </Wrapper>
      )}
    </Accordion>
  );
};

export default ProductInfoAccordion;
